import { parse } from 'date-fns';
import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export const dateFormat = 'dd-MMM-yyyy';

export const timeZone = 'CET';

export const stringToDate = (value: string) => zonedTimeToUtc(parse(value, dateFormat, new Date()), timeZone);

const formatTime = (date: Date) =>
    format(utcToZonedTime(date, timeZone), dateFormat, {
        timeZone,
    });

export const dateToString = (date: Date | null) => (date ? formatTime(date).toUpperCase() : '');

export const secondsToDate = (seconds: number) => formatTime(new Date(seconds));
